import React from 'react';
import CustomScrollTrigger from 'js/wrapper/CustomScrollTrigger';
import { Parallax } from 'react-scroll-parallax';
import GoogleMap from 'google-map-react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { useAbstractCmsElement } from 'components/cms/hooks/useAbstractCmsElementNew';

import { GOOGLE_MAPS_KEY, mapOptions } from 'js/constants';

function CmsElementMap(props) {
  const {
    editMode,
    index,
    showElementSettings,
    appIntl, // Provided by parent or another hook like useIntl
  } = props;

  // CMS Logic via Hook (replaces AbstractCmsElement class logic)
  const {
    shown,
    setShown,
    getMainId,
    getCustomId,
    getParamValue,
    getBackgroundStyle,
    elementStyleTag,
    getParallaxData,
    getAppendHtml,
    cssClasses,
    responsiveClasses,
  } = useAbstractCmsElement(props);

  // dnd-kit Sortable Hook
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: index,
    disabled: !editMode,
  });

  // dnd-kit styles for the movement
  const dndStyle = {
    transform: CSS.Translate.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 1000 : 'auto',
    position: 'relative',
    width: '100%',
    cursor: editMode ? 'move' : 'default',
  };

  // Map Position and UI Constants
  const shownClass = shown ? 'elem-shown ' : 'elem-hidden ';
  const mapHeight = getParamValue('mapHeight', 300);

  const position = {
    lat: parseFloat(getParamValue('mapLat', 49.4456943)),
    lng: parseFloat(getParamValue('mapLng', 7.7704389)),
  };

  const innerContent = (
    <div
      id={getMainId()}
      className={`ms-map ${shownClass} ${cssClasses} ${responsiveClasses}`}
      onClick={(e) => editMode && showElementSettings(e, index)}
      style={{
        ...getBackgroundStyle(),
        height: `${mapHeight}px`,
      }}
    >
      {/* Dynamic CSS styles (Animations/Custom CSS) */}
      {elementStyleTag}

      <GoogleMap
        bootstrapURLKeys={{
          key: GOOGLE_MAPS_KEY,
          language: appIntl?.locale || 'en',
          libraries: ['places'],
        }}
        center={position}
        defaultZoom={parseInt(getParamValue('mapZoom', 11))}
        options={mapOptions}
      />

      {getAppendHtml()}
    </div>
  );

  const parallaxData = getParallaxData();

  return (
    <div ref={setNodeRef} style={dndStyle} {...attributes} {...listeners}>
      {/*
          Stable wrapper for ScrollTrigger (React 19 Fix).
          Ensures a consistent DOM node for intersection observers.
      */}
      <div>
        <CustomScrollTrigger className="cms-overflow-fix" onEnter={() => setShown(true)} {...getCustomId()}>
          {parallaxData ? (
            <Parallax {...parallaxData}>
              {innerContent}
            </Parallax>
          ) : (
            innerContent
          )}
        </CustomScrollTrigger>
      </div>
    </div>
  );
}

export default CmsElementMap;
